import ctt from '@/utils/const';

export default {
  methods: {
    stateIcon(state, types) {
      if (
        types === undefined ||
        state === undefined ||
        types.length === 0 ||
        state === ctt.POINT_STATE_FAULT ||
        state === ctt.POINT_STATE_COLLECT
      ) {
        return ['icon-ico-correct'];
      } else {
        return types.map(type => {
          switch (type) {
            case 'smokeMod':
              return 'icon-fire';
            case 'tvocMod':
              return 'icon-dupin';
            case 'bioMod':
              return 'icon-iconmonstr-danger--icon';
            case 'cwaMod':
              return 'icon-chemical-weapon';
            case 'nuclearMod':
            case 'gcameraMod':
              return 'icon-he';
            case 'sysMod':
              return 'icon-xiuli';
            case 'weather':
              return 'icon-weather';
            default:
              return 'icon-ico-correct';
          }
        });
      }
    }
  }
};
